import * as React from 'react';
/**
 * Simple wrapping component. Note: ORDER MATTERS. Please follow the order supplied in the examples
 */
export const UtilityNav = ({ children, }) => {
    return React.createElement("div", { className: "dpc-GlobalHeader-UtilityNav" }, children);
};
UtilityNav.displayName = 'UtilityNav';
